import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      fill: "#fff"
    }, [
      _createElementVNode("path", { d: "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" })
    ], -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".4",
      d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z",
      mask: "url(#a)"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.979 16H2a2 2 0 0 1-.695-.127c.969-.05 1.4.073 1.709.123l2.75-8.154c.173.681.542 2.092.542 2.102l.079.372c.079.36.144.65.144.918 0 .398-.14.756-.584 1.236l.073.22c.227.144.649.275.948.29.094.472.63 1.194 1.009 1.529.378-.335.916-1.053 1.01-1.53.302-.014.72-.14.948-.29l.072-.22c-.443-.48-.584-.837-.584-1.235 0-.267.064-.557.143-.918l.08-.372c.002-.009.368-1.42.54-2.102zm1.706-.123A2 2 0 0 1 14 16h-1.021c.308-.05.74-.173 1.706-.123M14 0a2 2 0 0 1 2 2v12c0 .517-.198.986-.52 1.34a5.7 5.7 0 0 1-1.24-1.795l-.169-.458c-.768-2.137-2.29-6.499-2.697-8.668a3.65 3.65 0 0 1 .005-1.823c.117-.512.306-1.054.519-1.443q.13-.223.287-.424l.03-.03c.162-.2.317-.346.44-.446L12.55 0c-.512.234-1.59.762-2.253 1.38C9.98 1.075 9.38.762 8.94.617l-.083.21c.054.058.062.066.094.125v.012c.274.376.667.979.527 1.912l-.017.153c-.035.357-.112.699-.182 1.011l-.083.39c-.005.022-1.05 4.354-1.222 5.034A948 948 0 0 1 6.753 4.43c0-.009-.081-.383-.083-.391-.068-.31-.144-.644-.18-.993a1.3 1.3 0 0 1-.027-.238c-.1-.82.268-1.485.527-1.845V.952a.6.6 0 0 1 .094-.126L7.001.617c-.44.145-1.038.458-1.355.763C4.982.762 3.904.23 3.393 0l-.105.253a3 3 0 0 1 .469.476c.104.13.201.276.288.424.202.371.384.88.502 1.37a3.6 3.6 0 0 1 .126 1.246c-.144 1.815-1.918 6.967-2.766 9.356L1.9 13.1l-.003.01.011.015-.147.416a5.7 5.7 0 0 1-1.243 1.797A2 2 0 0 1 0 14V2a2 2 0 0 1 2-2z"
    }, null, -1)
  ])))
}
export default { render: render }